import me from './me'
import users from './users'
import socials from './socials'
import countries from './countries'
import images from './images'
import videos from './videos'
import liveBytes from './liveBytes'
import pages from './pages'

export default {
  me,
  users,
  socials,
  countries,
  images,
  videos,
  liveBytes,
  pages
}
